import Data from './Data'
import SetData from './SetData'

export default Data

export {

	Data,
	SetData

}



// WEBPACK FOOTER //
// ./src/js/_core/models/Data/index.jsx